module.exports = __webpack_public_path__ + "assets/img/darach.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/darach.png
// module id = 1925
// module chunks = 0